<template>

    <div class="galaxy::common-canvas-editor-canvas-pageOverlay-SelectionAlternatives tw-absolute tw-rounded tw-bg-white tw-shadow-xl tw-pt-4 tw-pr-4 tw-pb-3 tw-pl-4" :style="positionStyle">

        <div class="tw-mb-2 tw-text-gray-600 label">Welke bedoelde je?</div>

        <button
            v-for="(editor, index) in alternativeSelection.editors"
            :key="editor._uid"
            class="tw-block tw-bg-transparent tw-border-0 tw-p-0 tw-text-gray-700 hover:tw-text-gray-600 tw-my-2 tw-cursor-pointer tw-text-sm"
            @click="selection.setSelection(editor)"
            @mouseover="selection.setHover(editor)"
            @mouseout="selection.setHover(null)">

            <!-- TODO Implement correct way to determine tree.
            <i class="fal fa-fw fa-level-up fa-rotate-90 text-gray-500" :style="{ marginLeft: (index * 10) + 'px' }"></i>
            -->

            <i :class="editor.$options.appearance().icon" class="tw-mr-1 icon"></i>
            <span>{{ editor.$options.appearance().name }}</span>

        </button>

    </div>

</template>

<script>

    export default {

        inject: [
            '$pageComponent'
        ],

        data()
        {
            return {
                positionStyle: {},
            };
        },

        mounted()
        {
            this.initPosition();
        },

        methods: {

            initPosition()
            {
                // Start listening for window resize.
                $(window).bind('orientchange resize', this.managePosition);

                // Manage right now.
                this.managePosition();
            },

            // TODO Improve by checking bottom + fixed scrolling?
            managePosition()
            {
                // Determine position CSS due to having alternatives?
                if(this.alternativeSelection?.editors?.length <= 1)
                    return this.positionStyle = {};

                // Determine maxes.
                const margin = 15;

                let maxLeft = this.$pageComponent().element.width() - $(this.$el).outerWidth() - margin;
                let maxBottom = this.$pageComponent().element.height() - $(this.$el).outerHeight() - margin;

                // Calculate and set position.
                this.positionStyle = {
                    left: Math.max(margin, Math.min(this.alternativeSelection.mouseCoords.x, maxLeft)) + 'px',
                    top: Math.max(margin, Math.min(this.alternativeSelection.mouseCoords.y, maxBottom)) + 'px',
                };
            },

        },

        beforeDestroy()
        {
            // Stop listening for window resize.
            $(window).unbind('orientchange resize', this.managePosition);
        },

        computed: {

            selection()
            {
                return this.$pageComponent()?.selection;
            },

            alternativeSelection()
            {
                return this.selection.alternativeSelection;
            },

        },

        watch: {

            // Called once the selection changed while this component was shown.
            'alternativeSelection.editors'()
            {
                this.managePosition();
            },

        },

    }

</script>

<style lang="scss" scoped>

    .galaxy\:\:common-canvas-editor-canvas-pageOverlay-SelectionAlternatives {

        button {
            outline: 0;

            i.icon {
                color: #3182ce;
            }
        }

    }

</style>